export const THEME_STORAGE_KEY = 'jobseeqrSeekersTheme';

export const THEMES = Object.freeze({
  DARK: 'dark',
  LIGHT: 'light',
});

export function normalizeTheme(value) {
  return value === THEMES.LIGHT ? THEMES.LIGHT : THEMES.DARK;
}

export function getStoredTheme() {
  if (typeof window === 'undefined') return THEMES.DARK;

  try {
    return normalizeTheme(window.localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return THEMES.DARK;
  }
}

export function applyTheme(theme) {
  const nextTheme = normalizeTheme(theme);

  if (typeof document !== 'undefined') {
    document.documentElement.dataset.theme = nextTheme;
    document.documentElement.style.colorScheme = nextTheme;

    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) {
      themeColor.setAttribute('content', nextTheme === THEMES.LIGHT ? '#ffffff' : '#031128');
    }
  }

  return nextTheme;
}

export function setThemePreference(theme) {
  const nextTheme = applyTheme(theme);

  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, nextTheme);
    } catch {
      // The visual preference still applies for this session when storage is unavailable.
    }
  }

  return nextTheme;
}

export function initializeTheme() {
  return applyTheme(getStoredTheme());
}
